import React, { useState } from "react";
import AboutUsSection from "../../components/CommonComponents/AboutUsSection";
import SearchFAQ from "./SearchFAQ";
import { Box } from "@mui/material";
import HowItWorksSection from "../../components/CommonComponents/HowItWorksSection";
import InventoryPaymentSetupSection from "../../components/CommonComponents/InventoryPaymentSetupSection";

const CustomerSupport = ({isPublic}) => {
  const [isFaqVisible, setIsFaqVisible] = useState(false);
  return (
    <div>
      
      { !isFaqVisible ? <SearchFAQ setIsFaqVisible={setIsFaqVisible} /> 
      : (
        <>
          <AboutUsSection isPublic={isPublic} setIsFaqVisible={setIsFaqVisible} isCustomerSupport={true}/>
          <HowItWorksSection />
          <InventoryPaymentSetupSection isCustomerSupport={true}/>
          <Box sx={{ height: "60px", backgroundColor: "white" }}></Box>
        </>
      )}
    </div>
  );
};

export default CustomerSupport;
